/* eslint-disable check-file/filename-blocklist */
export enum LoadingPriority {
	PAINT = 0,
	AFTER_PAINT = 1,
	ACTIVATABLE = 2,
	LAZY = 3,
	BACKGROUND = 4,
	MAX_PRIORITY = BACKGROUND,
}

export const NOOP = () => null;
